'use client';

import React from 'react';
import Layout from '../../components/Layout';
import SubDocsLayout from '../../components/SubDocsLayout';
import useTranslation from '../../lib/translation';
import SEOHead from '../../components/SEOHead';

const CodingLanguages = () => {
  const { t, lang } = useTranslation('common');

  return (
    <Layout>
      <SEOHead
        title={
          lang === 'lt'
            ? Array.isArray(t('developerTools.pageTitle')) ? (t('developerTools.pageTitle') as string[]).join(' ') : (t('developerTools.pageTitle') as string)
            : 'Developer tools | LB Websites'
        }
        description={
          lang === 'lt'
            ? Array.isArray(t('developerTools.description')) ? (t('developerTools.description') as string[]).join(' ') : (t('developerTools.description') as string)
            : 'Learn about LB Visible developing tools.'
        }
        keywords='Next.js, React, TypeScript, Tailwind CSS, Firebase, modern web development, developer tools, web technologies'
        canonicalUrl={
          lang === 'lt' ? '/lt/sub/kurimo-irankiai' : '/sub/developer-tools'
        }
        lang={lang}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name:
            lang === 'lt'
              ? Array.isArray(t('developerTools.pageTitle')) ? (t('developerTools.pageTitle') as string[]).join(' ') : (t('developerTools.pageTitle') as string)
              : 'Developer tools | LB Websites',
          description:
            lang === 'lt'
              ? Array.isArray(t('developerTools.description')) ? (t('developerTools.description') as string[]).join(' ') : (t('developerTools.description') as string)
              : 'Learn about LB Visible developing tools.',
          url: `https://www.lbvisible.com${
            lang === 'lt' ? '/lt/sub/kurimo-irankiai' : '/sub/developer-tools'
          }`,
          inLanguage: lang === 'lt' ? 'lt' : 'en',
          provider: {
            '@type': 'Organization',
            name: 'LB Visible',
          },
        }}
      />

      <SubDocsLayout>
        <h1 className='text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white mb-4 text-left'>
            {lang === 'lt'
              ? t('developerTools.heading')
              : 'Coding Languages & Technologies'}
          </h1>
          <p className='text-base text-gray-600 dark:text-gray-300 mb-10 text-left leading-relaxed'>
            {lang === 'lt'
              ? t('developerTools.subtitle')
              : 'At LB Visible, we build every project using a hand-picked stack of modern, scalable, and secure technologies. Each tool in our workflow is chosen to ensure performance, user experience, and future-ready architecture.'}
          </p>

          <ul className='space-y-6'>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>Next.js:</span>{' '}
              {lang === 'lt'
                ? t('developerTools.tools.codeEditor.desc')
                : 'A powerful React framework that enables server-side rendering, static generation, and lightning-fast performance. Perfect for SEO and production-ready websites.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>React.js:</span>{' '}
              {lang === 'lt'
                ? t('developerTools.tools.debugger.desc')
                : 'The industry-standard JavaScript library for creating dynamic, responsive, and highly interactive user interfaces.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>Node.js:</span>{' '}
              {lang === 'lt'
                ? t('developerTools.tools.versionControl.desc')
                : 'A server-side runtime that allows scalable backend logic and seamless API integration—ideal for custom dashboards, form handling, and database access.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                JavaScript & TypeScript:
              </span>{' '}
              {lang === 'lt'
                ? t('developerTools.tools.testing.desc')
                : 'Core languages used to build the logic of every page. TypeScript brings additional type safety, reliability, and maintainability to the codebase.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>Tailwind CSS:</span>{' '}
              {lang === 'lt'
                ? t('developerTools.tools.deployment.desc')
                : 'A utility-first CSS framework that allows rapid design implementation with full control over responsiveness and theming—perfect for custom UI at scale.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>Sass (SCSS):</span>{' '}
              {lang === 'lt'
                ? t('developerTools.tools.codeEditor.desc')
                : 'A CSS preprocessor that helps us write more structured and reusable styles when custom modules are required beyond Tailwind.'}
              </div>
            </li>
          </ul>
      </SubDocsLayout>
    </Layout>
  );
};

export default CodingLanguages;
